module.exports = __webpack_public_path__ + "img/Chemistry Building, I.I.T., Madras.62acc719.jpg";